import React, { useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";

const DonutChart = ({
  chartLabels = [],
  series = [],
  title = "",
  type = "donut",
  noCard = false,
}) => {
  const [options] = useState({
    labels: chartLabels,
    legend: {
      position: "bottom",
      fontSize: "13px",
      fontFamily: "Montserrat, sans-serif",
      fontWeight: 500,
      markers: { width: 10, height: 10, radius: 3 },
      itemMargin: { horizontal: 10 },
    },
    colors: ["#038edc", "#5fd0f3", "#f34e4e", "#ffb800", "#51d28c", "#564ab1"],
    stroke: {
      width: 3,
      colors: ["#fff"],
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "65%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              fontSize: "13px",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 600,
              color: "#9299a8",
            },
            value: {
              fontSize: "22px",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              color: "#111827",
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${Math.round(val)}%`,
      style: {
        fontSize: "12px",
        fontFamily: "Montserrat, sans-serif",
        fontWeight: 600,
      },
      dropShadow: { enabled: false },
    },
    states: {
      hover: { filter: { type: "darken", value: 0.85 } },
      active: { filter: { type: "darken", value: 0.75 } },
    },
    tooltip: {
      style: { fontSize: "13px", fontFamily: "Montserrat, sans-serif" },
    },
    chart: {
      dropShadow: {
        enabled: true,
        top: 4,
        left: 0,
        blur: 12,
        color: "#000",
        opacity: 0.10,
      },
    },
    responsive: [],
  });

  if (!chartLabels.length || !series.length) return null;

  const inner = (
    <>
      {title && <h5 className="card-title mb-3" style={{ fontSize: 14, fontWeight: 600 }}>{title}</h5>}
      <Chart options={options} series={series} type={type} width="100%" />
    </>
  );

  if (noCard) return <div>{inner}</div>;

  return (
    <Card className="d-flex justify-content-center align-items-center">
      <Card.Body>{inner}</Card.Body>
    </Card>
  );
};

export default DonutChart;
